import { WORKFLOWS_PUBLISH_WORKFLOW_API, WORKFLOWS_SAVE_WORKFLOW_API } from 'Constant/api'
import { t } from 'i18next'
import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { authService } from 'Service/Axios'

const Header = ({ workflowDetail, nodes, edges }) => {
    const linkURI = `http://localhost:3000/auth/workflow/publish/${workflowDetail?.workflowId}`

    const handlelinkURI = (e) => {
        setopenCopy(!openCopy);
        navigator.clipboard.writeText(linkURI);
        toast.success("Copied Successfully!");
    };

    const [openCopy, setopenCopy] = useState(false);

    const handlePublish = async () => {
        const payload = {
            gid: workflowDetail.workflowId,
            nodes: nodes,
            edges: edges
        }
        const response = await authService(WORKFLOWS_PUBLISH_WORKFLOW_API, "POST", payload);
        if (response) {
            setopenCopy(!openCopy);
            toast.success("Published Successfully!");
        }
    }

    const handleSave = async () => {
        const payload = {
            gid: workflowDetail.workflowId,
            nodes: nodes,
            edges: edges
        }
        const response = await authService(WORKFLOWS_SAVE_WORKFLOW_API, "POST", payload);
        if (response) {
            toast.success("Saved Draft!");
        }
    }

    return (
        <div className="formeditor-header bg-white rounded-top d-flex align-items-center shadow-sm relative">
            <Button variant="editorclose border-0 bg-transparent border">
                <i className="bx bx-x bx-md"></i>
            </Button>
            <div className="headereditor-title border-start py-3 ps-3">
                <h3>{workflowDetail?.name}</h3>
                <div className="headereditor-sub-title d-flex align-items-center">
                    <i className="bx bx-folder bx-xs me-1"></i>
                    {/* {workflowDetail?.name}{" "} */}
                </div>
            </div>
            <div className="d-flex align-items-center ms-auto">
                <div className="editor-action-btns ms-2 d-flex gap-2 align-items-center py-3 px-3">
                    <Button variant="gray-light btn-sm" onClick={handleSave}>Save</Button>

                    <Button variant="primary btn-sm" onClick={handlePublish}>Publish</Button>
                    {openCopy && (
                        <div className="p-3 border-0 dropdown-menu-custom shadow max-300">
                            <form className="">
                                <div className="mb-3">
                                    <label className="form-label" for="getlink">
                                        {t("common.label.getLink")}
                                    </label>
                                    <div className="gap-2 input-group">
                                        <input
                                            aria-label="Recipient's username"
                                            aria-describedby="basic-addon2"
                                            id="getlink"
                                            className="rounded-1 form-control form-control-sm bg-grey-50 text-grey-700"
                                            value={linkURI}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-dark rounded-1"
                                            onClick={handlelinkURI}
                                        >
                                            {t("common.button.copy")}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Header